import { Pipe, PipeTransform } from '@angular/core';

import { getProperty } from '@shared/utils';

@Pipe({
  name: 'mapByProperty',
})
export class MapByPropertyPipe implements PipeTransform {
  transform(list: any[], property: string): any[] {
    if (!list?.length) {
      return [];
    }

    return list.filter((x) => !!x).map((item) => getProperty(item, property));
  }
}
